import Carousel from './carousel';

const HERO_OPTIONS = {
    cellSelector: '.hero__slide',
    wrapAround: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    pageDots: true,
    prevNextButtons: true,
    imagesLoaded: true,
    setGallerySize: false,
};

class Hero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.carousel = new Carousel(self.elem, HERO_OPTIONS).init();
        return self;
    }
}

export default Hero;
